import React from 'react';

const WhatsAppFloat: React.FC = () => (
  <a
    href="https://wa.me/919495917116"
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-6 right-6 z-50 animate-bounce-slow"
    title="Chat on WhatsApp"
    style={{ boxShadow: '0 4px 24px 0 rgba(37, 211, 102, 0.25)' }}
  >
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="28" cy="28" r="28" fill="#25D366" />
      <path d="M40.25 35.75c-.53-.35-3.18-1.57-3.68-1.75-.5-.18-.86-.26-1.23.18-.36.44-1.41 1.75-1.73 2.12-.32.35-.64.39-1.18.13-.53-.26-2.25-.83-4.29-2.65-1.59-1.41-2.67-3.15-2.98-3.68-.32-.53-.03-.82.24-1.08.25-.25.56-.65.85-.97.28-.32.37-.56.56-.94.18-.38.09-.71-.04-.97-.13-.26-1.18-2.85-1.62-3.9-.43-1.03-.87-.89-1.23-.91-.32-.02-.7-.02-1.08-.02-.38 0-.97.14-1.48.71-.5.56-1.95 1.91-1.95 4.65 0 2.74 2 5.39 2.28 5.77.28.38 3.94 6.03 9.7 8.22 1.36.47 2.42.75 3.25.96 1.36.36 2.6.31 3.58.19 1.09-.13 3.37-1.38 3.85-2.72.47-1.34.47-2.49.33-2.72-.13-.23-.48-.36-1.01-.62z" fill="#fff"/>
    </svg>
  </a>
);

export default WhatsAppFloat; 